import G2 from '@antv/g2'

const AntvG2 = {
	Guide: (data) => {
		var chart = new G2.Chart({
			container: data.el,
			forceFit: true,
			height: data.height,
			padding: data.padding || 0
		});
		chart.source(data.source);
		chart.legend(false);
		chart.tooltip({
			showTitle: false
		});
		chart.facet('rect', {
			fields: ['type'],
			padding: 0,
			showTitle: false,
			eachView: function eachView(view, facet) {
				var data = facet.data;
				var color = void 0;
				if (data[0].type === data[0].type) {
					color = '#0066CC';
				} else {
					color = '#f0657d';
				}

				data.push({
					type: data[0].title || '',
					value: 100 - data[0].value
				});
				view.source(data);
				view.coord('theta', {
					radius: 1,
					innerRadius: 0.8
				});
				view.intervalStack().position('value').color('type', [color, '#eceef1']).opacity(1);
				view.guide().html({
					position: ['50%', '50%'],
					html: '<div class="g2-guide-html"><p class="title">' + data[0].type + '</p><p class="value" style="text-align: center">' + (data[0].value + data[0].unit) + '</p></div>'
				});
			}
		});
		chart.render();
	},
	Shape: (data) => {
		// 可以通过调整这个数值控制分割空白处的间距，0-1 之间的数值
		var sliceNumber = 0.01;
		var _data = data.list;
		var _total = 0;

		// 自定义 other 的图形，增加两条线
		G2.Shape.registerShape('interval', 'sliceShape', {
			draw: function draw(cfg, container) {
				var points = cfg.points;
				var path = [];
				path.push(['M', points[0].x, points[0].y]);
				path.push(['L', points[1].x, points[1].y - sliceNumber]);
				path.push(['L', points[2].x, points[2].y - sliceNumber]);
				path.push(['L', points[3].x, points[3].y]);
				path.push('Z');
				path = this.parsePath(path);
				return container.addShape('path', {
				attrs: {
					fill: cfg.color,
					path: path
				}
			});
			}
		});

		var chart = new G2.Chart({
			container: 'antv-g2-behavior',
			forceFit: true,
			height: 400,
			padding: [10, 0, 130, 0]
		});
		chart.source(_data);
		chart.coord('theta', {
			innerRadius: 0.7
		});
		chart.tooltip({
			showTitle: false,
		});
		chart.legend({
			useHtml: true,
			containerTpl: '<div class="g2-legend"><div class="g2-legend-list"></div></div>',
			itemTpl: (value, color, checked, index) => {
				const obj = data.list[index];
				checked = checked ? 'checked' : 'unChecked';
				return '<div class="g2-legend-list-item item-' + index + ' ' + checked + '" data-value="' + value + '" data-color=' + color + '>' +
							'<span><i class="g2-legend-marker" style="width:10px; height:10px; display:inline-block; margin-top:-4px; margin-right:10px; background-color:' + color + ';"></i>' +
							'<span class="g2-legend-text">' + value + '</span></span> ' + 
							'<span>' + obj.value + '</span>' +
						'</div>';
			}
		});
		chart.guide().html({
			position: ['50%', '50%'],
			html: '<div class="g2-guide-html behavior"><p class="title">'+ data.title +'</p><p class="value">'+ data.total +'</p></div>'
		});
		chart.intervalStack().position('value').color('name').label('value', {
			formatter: (val, item, index) => {
				if (index == 0) _total = 0;
				_total += val*1;
				document.querySelector('.behavior .value').innerHTML = _total;
			}
		}).shape('sliceShape');

		chart.render();
	},
	Line: (data) => {
		var chart = new G2.Chart({
			container: data.el,
			forceFit: true,
			height: data.height,
			padding: data.padding || [30, 50, 50, 80]
		});
		chart.source(data.list);
		chart.scale(data.position[1], {
			min: 0
		});
		chart.scale(data.position[0], {
			range: [.1, .9]
		});
		chart.tooltip({
			crosshairs: {
				type: 'line'
			},
			itemTpl: '<div>'+ data.title +'： {value}'+ data.unit +'</div>'
		});
		chart.line().position(data.position[0] + '*'+ data.position[1]);
		chart.point().position(data.position[0] + '*'+ data.position[1]).size(4).shape('circle').style({
			stroke: '#fff',
			lineWidth: 1
		});
		chart.render();
	},
	Bar: (data) => {
		var chart = new G2.Chart({
			container: data.el,
			forceFit: true,
			height: data.height,
			padding: data.padding || 0
		});
		chart.source(data.list);
		chart.scale(data.position[1], {
			alias: '占比（%）',
			min: 0,
			tickCount: 5
		});
		chart.tooltip({
			crosshairs: {
				type: 'bar'
			},
			itemTpl: '<div>'+ data.title +'： {value}' +'</div>'
		});
		chart.axis(data.position[0], {
			label: {
				textStyle: {
					fill: '#fff',
					opacity: .7,
					fontSize: 14
				}
			},
			tickLine: {
				alignWithLabel: false,
				length: 0
			}
		});
		chart.axis(data.position[1], {
			label: {
				textStyle: {
					fill: '#fff',
					opacity: .7,
					fontSize: 14
				},
				formatter: function formatter(val) {
					return val + '%';
				}
			},
			grid: null
		});
		chart.tooltip({
			share: true
		});

		chart.interval().position(data.position[0] + '*'+ data.position[1]).opacity(1).color(data.position[0], ['l(90) 0:#009FE8 1:#0066cc']).label(data.position[1], {
			useHtml: true,
			htmlTemplate: function htmlTemplate(text, item) {
				var a = item.point;
				a.percent = String(parseInt(a.percent * 100))/100;
				return '<div class="g2-label-item"><div class="g2-label-item-percent">' + a.percent + '%</div></div>';
			}
		});
		chart.render();
	},
	LineBar: (data) => {
		var chart = new G2.Chart({
			container: data.el,
			forceFit: true,
			height: 310.5,
			padding: [20, 40, 95, 40]
		});

		chart.source(data.source, {
			call: {
				min: 0
			},
			complate: {
				min: 0
			},
			count: {
				min: 0
			}
		});

		chart.legend({
			custom: true,
			allowAllCanceled: true,
			items: [{
				value: data.title[0],
				marker: {
					symbol: 'square',
					fill: '#3182bd',
					radius: 5
				}
			}, {
				value: data.title[1],
				marker: {
					symbol: 'hyphen',
					stroke: '#fdae6b',
					radius: 5,
					lineWidth: 3
				}
			}],
			onClick: function onClick(ev) {
				var item = ev.item;
				var value = item.value;
				var checked = item.checked;
				var geoms = chart.getAllGeoms();
				for (var i = 0; i < geoms.length; i++) {
					var geom = geoms[i];
					if (geom.getYScale().field === value) {
						if (checked) {
							geom.show();
						}
					} else {
						geom.hide();
					}
				}
			}
		});
		chart.axis('complate', {
			grid: null,
			label: {
				textStyle: {
					fill: '#fdae6b'
				}
			}
		});
		chart.interval().position('time*count').color('#3182bd');
		chart.line().position('time*complate').color('#fdae6b').size(3).shape('smooth');
		chart.point().position('time*complate').color('#fdae6b').size(3).shape('circle');
		chart.render();
	}
}

export default AntvG2